import { render, staticRenderFns } from "./dmDataInput.vue?vue&type=template&id=115fd283&"
import script from "./dmDataInput.vue?vue&type=script&lang=js&"
export * from "./dmDataInput.vue?vue&type=script&lang=js&"
import style0 from "./dmDataInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports